import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'

class TariffsApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public getTariffsList() {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/tariffs/',
    })
  }
}

export const tariffsApi = new TariffsApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
